var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    focusable: "false",
    className: "chakra-icon css-d1v49d",
    "aria-label": "google",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 0,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "m3.524 16.93 3.363-2.571a5.934 5.934 0 0 1-.296-1.859c0-.65.104-1.275.296-1.859L3.524 8.069A10.01 10.01 0 0 0 2.5 12.5c0 1.594.368 3.097 1.024 4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M6.887 10.641a5.898 5.898 0 0 1 5.613-4.05c1.41 0 2.682.5 3.682 1.318L19.09 5c-1.773-1.545-4.046-2.5-6.591-2.5a9.97 9.97 0 0 0-8.976 5.57l3.363 2.571Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M12.5 22.5a9.97 9.97 0 0 1-8.977-5.572l3.361-2.577a5.898 5.898 0 0 0 5.616 4.058c1.285 0 2.423-.302 3.325-.871l3.193 2.471C17.27 21.636 14.939 22.5 12.5 22.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M12.5 10.682h9.318a8.3 8.3 0 0 1 .227 1.818c0 3.26-1.192 5.803-3.027 7.51l-3.193-2.473c1.044-.658 1.77-1.674 2.039-2.991H12.5v-3.864Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.c189857b64e93ee48b287dd2600157c7.svg";
export { ForwardRef as ReactComponent };